(function () {
  'use strict';

  var root = document.querySelector('[data-rm-pp-survey]');
  if (!root) return;

  var QUESTIONS = [
    'What made you pick us over everything else out there?',
    'Where are you planning to wear it? Gym only, or does it come with you?',
    'What should we make next?'
  ];
  var PLACEHOLDERS = [
    'Type your answer here…',
    'Type your answer here…',
    'Tell us what you want to see…'
  ];
  var sourceEmail = window.RM_SURVEY_EMAIL;
  delete window.RM_SURVEY_EMAIL;

  var state = {
    email: '',
    answers: ['', '', ''],
    step: 'email',
    returnStep: 0,
    emailEdit: false,
    emailError: '',
    answerError: '',
    submissionError: '',
    submitting: false,
    completed: false,
    submissionId: '',
    completedAt: '',
    submissionSignature: ''
  };

  function isValidEmail(value) {
    if (typeof value !== 'string' || value.length === 0 || value.length > 254) {
      return false;
    }
    if (/[\s<>"'\u0000-\u001F\u007F]/.test(value)) return false;

    var at = value.indexOf('@');
    if (at <= 0 || at !== value.lastIndexOf('@') || at === value.length - 1) {
      return false;
    }

    var local = value.slice(0, at);
    var domain = value.slice(at + 1);
    if (!domain || domain.indexOf('.') === -1 || domain.indexOf('..') !== -1) {
      return false;
    }
    if (local.indexOf('..') !== -1 || local.charAt(0) === '.' || local.charAt(local.length - 1) === '.') {
      return false;
    }
    if (!/^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+$/.test(local)) return false;

    var labels = domain.split('.');
    for (var i = 0; i < labels.length; i += 1) {
      if (!/^[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/.test(labels[i])) {
        return false;
      }
    }
    return true;
  }

  function maskEmail(value) {
    var parts = value.split('@');
    return parts[0].slice(0, 1) + '•••@' + parts[1];
  }

  function answerIsValid(value) {
    return typeof value === 'string' && value.length <= 2000 && value.trim().length > 0;
  }

  function makeElement(tagName, className, text) {
    var node = document.createElement(tagName);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function clearRoot() {
    while (root.firstChild) root.removeChild(root.firstChild);
  }

  function storeUrl() {
    var value = root.getAttribute('data-store-url') || '/';
    return value.indexOf('{{') !== -1 ? '/' : value;
  }

  function privacyUrl() {
    var value = root.getAttribute('data-privacy-url') || '/policies/privacy-policy';
    return value.indexOf('{{') !== -1 ? '/policies/privacy-policy' : value;
  }

  function appendFooter(parent) {
    var footer = makeElement('footer', 'rm-pp-survey__footer');
    footer.setAttribute('role', 'contentinfo');

    var links = makeElement('div', 'rm-pp-survey__footer-links');
    var privacy = makeElement('a', 'rm-pp-survey__privacy', 'Privacy');
    privacy.href = privacyUrl();
    links.appendChild(privacy);
    var divider = makeElement('span', 'rm-pp-survey__footer-divider', '•');
    divider.setAttribute('aria-hidden', 'true');
    links.appendChild(divider);
    var shop = makeElement('a', 'rm-pp-survey__return', 'Return to shop');
    shop.href = storeUrl();
    links.appendChild(shop);
    footer.appendChild(links);
    footer.appendChild(makeElement(
      'p',
      'rm-pp-survey__privacy-note',
      'Your answers help shape what we make next. This survey does not subscribe you to marketing.'
    ));
    parent.appendChild(footer);
  }

  function appendBrand(parent) {
    var brand = makeElement('a', 'rm-pp-survey__wordmark');
    brand.href = storeUrl();
    brand.setAttribute('aria-label', 'RetroMuscle home');
    var logo = makeElement('img', 'rm-pp-survey__logo');
    logo.src = 'https://retromuscle.net/cdn/shop/files/LOGO_RETROMUSCLE_SITE_1a27cc0f-e82a-4f31-94b3-42f083e8dc28.png?v=1729207969&width=384';
    logo.alt = 'RetroMuscle';
    logo.width = 1800;
    logo.height = 1496;
    logo.loading = 'eager';
    logo.referrerPolicy = 'no-referrer';
    brand.appendChild(logo);
    parent.appendChild(brand);
  }

  function appendHeader(parent) {
    var header = makeElement('header', 'rm-pp-survey__header');
    header.setAttribute('role', 'banner');
    appendBrand(header);
    header.appendChild(makeElement('p', 'rm-pp-survey__eyebrow', 'Golden Era feedback'));
    parent.appendChild(header);
  }

  function appendIdentity(main) {
    var identity = makeElement('div', 'rm-pp-survey__identity');
    identity.appendChild(makeElement('span', '', 'Your answers are for '));
    var masked = makeElement('strong', '', maskEmail(state.email));
    masked.setAttribute('data-rm-email-mask', '');
    identity.appendChild(masked);
    var change = makeElement('button', 'rm-pp-survey__text-button', 'Not you? Change email');
    change.type = 'button';
    change.disabled = state.submitting;
    change.addEventListener('click', function () {
      state.returnStep = state.step;
      state.emailEdit = true;
      state.emailError = '';
      state.answerError = '';
      render(true);
    });
    identity.appendChild(change);
    main.appendChild(identity);
  }

  function focusHeading(heading) {
    window.requestAnimationFrame(function () {
      heading.focus({ preventScroll: true });
    });
  }

  function renderEmail(heading) {
    heading.textContent = 'Before we start';
    var intro = makeElement(
      'p',
      'rm-pp-survey__intro',
      state.emailEdit
        ? 'Enter the email you want connected to your answers.'
        : 'Let us know who we’re hearing from.'
    );
    heading.parentNode.appendChild(intro);

    if (state.emailEdit && state.email) {
      var current = makeElement('p', 'rm-pp-survey__current-email');
      current.appendChild(makeElement('span', '', 'Current email: '));
      var masked = makeElement('strong', '', maskEmail(state.email));
      masked.setAttribute('data-rm-email-mask', '');
      current.appendChild(masked);
      heading.parentNode.appendChild(current);
    }

    var form = makeElement('form', 'rm-pp-survey__form');
    form.noValidate = true;
    var label = makeElement('label', 'rm-pp-survey__label', 'Email address');
    label.htmlFor = 'rm-pp-email';
    form.appendChild(label);

    var input = document.createElement('input');
    input.id = 'rm-pp-email';
    input.name = 'email';
    input.type = 'email';
    input.autocomplete = 'email';
    input.inputMode = 'email';
    input.spellcheck = false;
    input.required = true;
    input.setAttribute('aria-describedby', 'rm-pp-email-help rm-pp-email-error');
    form.appendChild(input);
    form.appendChild(makeElement(
      'p',
      'rm-pp-survey__help',
      'We use this only to identify your response; it does not subscribe you to marketing.'
    )).id = 'rm-pp-email-help';

    var error = makeElement('p', 'rm-pp-survey__error', state.emailError);
    error.id = 'rm-pp-email-error';
    error.setAttribute('role', 'alert');
    error.setAttribute('aria-live', 'assertive');
    form.appendChild(error);

    var actions = makeElement('div', 'rm-pp-survey__actions');
    if (state.emailEdit) {
      var back = makeElement('button', 'rm-pp-survey__back', 'BACK');
      back.type = 'button';
      back.addEventListener('click', function () {
        state.emailEdit = false;
        state.emailError = '';
        state.step = state.returnStep;
        render(true);
      });
      actions.appendChild(back);
    }
    var submit = makeElement('button', 'rm-pp-survey__primary', 'CONTINUE');
    submit.type = 'submit';
    actions.appendChild(submit);
    form.appendChild(actions);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!isValidEmail(input.value)) {
        state.emailError = 'Enter a valid email address.';
        error.textContent = state.emailError;
        input.setAttribute('aria-invalid', 'true');
        return;
      }
      state.email = input.value;
      state.emailError = '';
      state.answerError = '';
      if (state.emailEdit) {
        state.emailEdit = false;
        state.step = state.returnStep;
      } else {
        state.step = 0;
      }
      render(true);
    });
    heading.parentNode.appendChild(form);
  }

  function renderQuestion(heading) {
    var index = state.step;
    heading.textContent = QUESTIONS[index];
    var progress = makeElement('p', 'rm-pp-survey__progress', (index + 1) + ' of 3');
    progress.setAttribute('aria-live', 'polite');
    progress.setAttribute('aria-label', 'Question ' + (index + 1) + ' of 3');
    heading.parentNode.appendChild(progress);
    appendIdentity(heading.parentNode);

    var form = makeElement('form', 'rm-pp-survey__form rm-pp-survey__question-form');
    form.noValidate = true;
    var label = makeElement('label', 'rm-pp-survey__label rm-pp-survey__question-label', QUESTIONS[index]);
    var textareaId = 'rm-pp-answer-' + index;
    label.htmlFor = textareaId;
    form.appendChild(label);

    var textarea = document.createElement('textarea');
    textarea.id = textareaId;
    textarea.name = 'answer-' + (index + 1);
    textarea.rows = 7;
    textarea.maxLength = 2000;
    textarea.required = true;
    textarea.disabled = state.submitting;
    textarea.placeholder = PLACEHOLDERS[index];
    textarea.setAttribute('aria-describedby', 'rm-pp-answer-help-' + index + ' rm-pp-answer-error-' + index);
    textarea.value = state.answers[index];
    form.appendChild(textarea);

    var help = makeElement('p', 'rm-pp-survey__help', 'Up to 2,000 characters.');
    help.id = 'rm-pp-answer-help-' + index;
    form.appendChild(help);
    var error = makeElement('p', 'rm-pp-survey__error', state.answerError);
    error.id = 'rm-pp-answer-error-' + index;
    error.setAttribute('role', 'alert');
    error.setAttribute('aria-live', 'assertive');
    form.appendChild(error);

    var actions = makeElement('div', 'rm-pp-survey__actions');
    if (index > 0) {
      var back = makeElement('button', 'rm-pp-survey__back', 'BACK');
      back.type = 'button';
      back.disabled = state.submitting;
      back.addEventListener('click', function () {
        if (state.submitting) return;
        state.answers[index] = textarea.value;
        state.answerError = '';
        state.step -= 1;
        render(true);
      });
      actions.appendChild(back);
    }
    var nextText = state.submitting ? 'SENDING…' : (index === QUESTIONS.length - 1 ? 'SUBMIT MY ANSWERS' : 'NEXT');
    var next = makeElement('button', 'rm-pp-survey__primary', nextText);
    next.type = 'submit';
    next.disabled = state.submitting;
    next.setAttribute('aria-busy', state.submitting ? 'true' : 'false');
    actions.appendChild(next);
    form.appendChild(actions);

    textarea.addEventListener('input', function () {
      state.answers[index] = textarea.value;
      if (state.answerError) {
        state.answerError = '';
        error.textContent = '';
        textarea.removeAttribute('aria-invalid');
      }
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      state.answers[index] = textarea.value;
      if (!answerIsValid(textarea.value)) {
        state.answerError = 'Please tell us a little more.';
        error.textContent = state.answerError;
        textarea.setAttribute('aria-invalid', 'true');
        return;
      }
      state.answerError = '';
      if (index < QUESTIONS.length - 1) {
        state.step += 1;
        render(true);
      } else {
        submitAnswers();
      }
    });
    heading.parentNode.appendChild(form);

    if (state.submissionError) {
      var submissionStatus = makeElement('p', 'rm-pp-survey__error rm-pp-survey__submission-status', state.submissionError);
      submissionStatus.setAttribute('role', 'status');
      submissionStatus.setAttribute('aria-live', 'assertive');
      heading.parentNode.appendChild(submissionStatus);
    }
  }

  function submissionSignature(answers) {
    return state.email + '\u001f' + answers.join('\u001f');
  }

  function submitAnswers() {
    if (state.submitting || state.completed) return;
    var answers = state.answers.map(function (answer) { return answer.trim(); });
    var signature = submissionSignature(answers);
    if (signature !== state.submissionSignature) {
      if (!window.crypto || typeof window.crypto.randomUUID !== 'function') {
        state.submissionError = 'We could not start the submission. Please try again.';
        render(false);
        return;
      }
      state.submissionId = window.crypto.randomUUID();
      state.completedAt = new Date().toISOString();
      state.submissionSignature = signature;
    }

    state.submissionError = '';
    state.submitting = true;
    render(false);
    var payload = {
      email: state.email,
      answers: answers,
      submissionId: state.submissionId,
      completedAt: state.completedAt
    };

    Promise.resolve().then(function () {
      if (typeof window.RMSurveySubmit !== 'function') {
        throw new Error('RMSurveySubmit is not available');
      }
      return window.RMSurveySubmit(payload);
    }).then(function () {
      state.submitting = false;
      state.completed = true;
      state.submissionError = '';
      render(true);
    }).catch(function () {
      state.submitting = false;
      state.submissionError = "We couldn't send your answers. Please try again.";
      render(false);
    });
  }

  function render(shouldFocusHeading) {
    clearRoot();
    root.setAttribute('aria-busy', state.submitting ? 'true' : 'false');
    appendHeader(root);

    var main = makeElement('main', 'rm-pp-survey__main');
    main.setAttribute('aria-label', 'RetroMuscle post-purchase survey');

    var panel = makeElement('section', 'rm-pp-survey__panel');
    var heading = makeElement('h1', 'rm-pp-survey__heading');
    heading.id = 'rm-pp-survey-heading';
    heading.tabIndex = -1;
    panel.appendChild(heading);

    if (state.completed) {
      panel.setAttribute('data-rm-survey-success', '');
      heading.textContent = 'Thank you for sharing.';
      panel.appendChild(makeElement(
        'p',
        'rm-pp-survey__success-copy',
        'Your answers help shape what we make next.'
      ));
      var shop = makeElement('a', 'rm-pp-survey__primary rm-pp-survey__shop-link', 'SHOP RETROMUSCLE');
      shop.href = storeUrl();
      panel.appendChild(shop);
    } else if (state.step === 'email' || state.emailEdit) {
      renderEmail(heading);
    } else {
      renderQuestion(heading);
    }

    main.appendChild(panel);
    root.appendChild(main);
    appendFooter(root);
    root.dataset.rmReady = 'true';
    if (shouldFocusHeading) focusHeading(heading);
  }

  if (isValidEmail(sourceEmail)) {
    state.email = sourceEmail;
    state.step = 0;
  }
  render(true);
}());
